import {useTranslation} from 'react-i18next';
import {OFFER_CONFIRMATION_TYPES} from '@chekin/core';
import {StyledButton} from './styled';
import {ShoppingCart} from 'lucide-react';

type Props = {
  type: OFFER_CONFIRMATION_TYPES;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
};
const AddToCartButton = ({className, disabled, onClick}: Props) => {
  const {t} = useTranslation();

  return (
    <StyledButton className={className} disabled={disabled} onClick={onClick}>
      <ShoppingCart />
      {t('book_experience_view.add_to_cart_button')}
    </StyledButton>
  );
};

export {AddToCartButton};
